import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Carrinho from '../../componentes/comuns/Carrinho';




const MonteoSeu = () => {
    return (
        <>
           
          <Header />
            <main>
               <div>
                    <Carrinho />
                </div>
            </main>
           <Footer/>
        </>
    );
}

export default MonteoSeu;